import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=12b2ef70&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12b2ef70')) {
      api.createRecord('12b2ef70', component.options)
    } else {
      api.reload('12b2ef70', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=12b2ef70&", function () {
      api.rerender('12b2ef70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23m9Z44veXyd5/JS/comp/openstreetmap.vue"
export default component.exports